module.exports = "mutation editEmployee($employeeId:ID!,$role:String){editEmployee(employeeId:$employeeId,role:$role){id type}}"